<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [class.d-none]="
    isVisibleAddNumberForm ||
    isShowSmartSmsClubFileProgresses ||
    isShowSmartSmsClubNumbers ||
    isShowClubStatusInGateway
  "
  [config]="pageConfig"
  (onAdd)="onCreate('', true)"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (onSelectAll)="onSelectAll($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
<!-- groupDeletion btn -->
  <!-- <div class="card-toolbar" before-btns>
    <div [matTooltip]="'common.groupDeletion' | translate">
      <button
        [disabled]="selectedIds?.length == 0"
        (click)="onGroupDeletion()"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        type="button"
        mat-ripple
      >
        <i class="mdi mdi-trash-can-outline mdi-20px tw-p-0 text-danger"></i>
      </button>
    </div>
  </div> -->
  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- checkbox -->
        <!-- <td>
          <div class="form-check tw-text-center">
            <input
              type="checkbox"
              class="form-check-input tw-mt-[1px]"
              (click)="onAddSelectedId($event, item?.id, row)"
              [attr.data-checkbox-id]="item.id"
            />
          </div>
        </td> -->

        <!-- id -->
        <td>
          <td-value copyToClipboard [value]="item?.id"></td-value>
        </td>

        <!-- title -->
        <td>
          <td-value copyToClipboard [value]="item?.title"></td-value>
        </td>

        <!-- CreationLocation -->
        <td>
          <span class="tw-text-sm">
            {{
              item?.creationLocation | enumToText : CreationLocationEnumValues
            }}</span
          >
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <!------------------------------- operations -------------------------------->

        <td class="sticky-td">
          <a mat-icon-button [matMenuTriggerFor]="menu">
            <i class="mdi mdi-dots-vertical text-navyBlue mdi-20px"></i>
          </a>

          <mat-menu #menu="matMenu" xPosition="before">
            <!-- add numbers -->
            <div
              mat-menu-item
              class="tw-flex-center text-navyBlue border-bottom"
              (click)="onAddNumbers(item.id)"
            >
              <i
                class="mdi mdi-plus-outline mdi-20px text-success tw-ml-[10px] ltr:tw-mr-[10px]"
              ></i>
              <span class="mat-menu-title tw-font-medium text-success">{{
                "common.addNumbers" | translate
              }}</span>
            </div>

            <!--Smart sms club file progresses-->
            <div
              mat-menu-item
              class="tw-flex-center border-bottom"
              (click)="onSmartSmsClubFileProgresses(item.id)"
            >
              <i
                class="mdi mdi-progress-alert mdi-20px text-info tw-ml-[10px] ltr:tw-mr-[10px]"
              ></i>
              <span class="mat-menu-title tw-font-medium text-info">{{
                "common.smartSmsClubFileProgresses" | translate
              }}</span>
            </div>

            <!--Smart Sms Club Numbers-->
            <div
              mat-menu-item
              class="tw-flex-center border-bottom"
              (click)="onSmartSmsClubNumbers(item.id)"
            >
              <i
                class="mdi mdi-cellphone mdi-20px text-gray tw-ml-[10px] ltr:tw-mr-[10px]"
              ></i>
              <span class="mat-menu-title tw-font-medium text-gray">{{
                "common.smartSmsClubNumbers" | translate
              }}</span>
            </div>

            <!-- ClubStatusInGateway button -->
            <div
              mat-menu-item
              class="tw-flex-center text-primary"
              (click)="onClubStatusInGateway(item.id, item.title)"
            >
              <i
                class="mdi mdi-card-text-outline mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-primary"
              ></i>
              <span class="mat-menu-title tw-font-medium">{{
                "common.clubStatusInGateway" | translate
              }}</span>
            </div>
          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- add numbers form -->
<ng-container *ngIf="isVisibleAddNumberForm">
  <app-add-numbers-form
    [clubId]="clubId"
    [formPageConfig]="formPageConfig"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-add-numbers-form>
</ng-container>

<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="'SmartSmsClub'"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>

<!-- smartSmsClubFileProgresses -->
<ng-container *ngIf="isShowSmartSmsClubFileProgresses">
  <app-smart-sms-club-file-progresses
    [clubId]="selectedClubId"
    (onBack)="isShowSmartSmsClubFileProgresses = false"
  >
  </app-smart-sms-club-file-progresses>
</ng-container>

<!-- smartSmsClubFileProgresses -->
<ng-container *ngIf="isShowSmartSmsClubNumbers">
  <app-smart-sms-club-numbers
    [clubId]="selectedClubId"
    (onBack)="isShowSmartSmsClubNumbers = false"
  >
  </app-smart-sms-club-numbers>
</ng-container>

<!--CampaignStatusInGateway-->
<ng-container *ngIf="isShowClubStatusInGateway">
  <app-club-status-in-gateway
    [smartSmsClubId]="clubId"
    [smartSmsClubTitle]="clubTitle"
    (closePage)="onHideClubStatusInGateway()"
  ></app-club-status-in-gateway>
</ng-container>
